import React from 'react'
import { LuPanelLeftClose, LuPanelLeftOpen } from 'react-icons/lu'
import { useSidebar } from '../SidebarContext'

const SidebarToggle = ({ style = {}, className = '' }) => {
  const { isCollapsed, toggleSidebar } = useSidebar()

  return (
    <button
      type="button"
      className={`sidebar-toggle-btn ${className}`.trim()}
      onClick={toggleSidebar}
      style={style}
      aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      aria-expanded={!isCollapsed}
      title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
    >
      {isCollapsed ? (
        <LuPanelLeftOpen size={22} strokeWidth={2} />
      ) : (
        <LuPanelLeftClose size={22} strokeWidth={2} />
      )}
    </button>
  )
}

export default SidebarToggle

